<template lang="pug">
  #MySa
    .title-area.text-center
      p.title 您尚未開啟VIP專屬1對1諮詢服務
      p.subtitle 請先選擇您的服務顧問!
    .bound-area
      .bound-wrap
        .bound-title
          span.number 1
          span 請選擇您欲綁定服務顧問的櫃點
        .bound-selector
          select(
            @change="clickCity"
            v-model="citySelect"
          )
            option(
              value=""
              disabled
              selected
            ) 請選擇區域
            option(
              v-for="(item, index) in getCity"
             :key="index"
             :value="index"
            ) {{item}}
          select(
             @change="clickStore"
              v-model="storeSelect"
          )
            option(
              value=""
              disabled
              selected
            ) 請選擇櫃點
            option(
              v-for="(store, index) in getStore"
              :key="index"
              :value="index"
            ) {{store}}
      .bound-wrap
        .bound-title
          span.number 2
          span 請選擇您欲綁定的服務顧問
        swiper.swiper(
          :options="swiperOption"
        )
          swiper-slide.mb-6(
            v-for="(item, index) in newSaList"
            :item="item"
          )
            .b-card
                .badge-img(
                    v-if="item.badge_image_url"
                  )
                    img(
                      :src="item.badge_image_url"
                    )
                .head-img
                  img(
                    :src="item.pic_url",
                    :onerror="defaultPhotoSticker"
                  )
                .name.font-weight-bold.mt-2 {{item.name}}
                .location.mb-2
                  i.fas.fa-map-marker-alt.mr-2
                  span {{item.store_name}}
                .skills.mb-3
                  p(
                    v-for="(skill, index) in item.skills"
                    :key="index"
                    style="font-size: 14px; margin-bottom: 5px;"
                  ) {{ skill }}
                button(
                  @click="selectBaHandler(item)"
                  :class="{'btn-primary': isSelected && isSelected.sa_id == item.sa_id}"
                ).btn-disabled.btn.mb-3 綁定 
          .swiper-pagination.bullet(
            slot="pagination"
          )
      .bound-wrap(
        v-show="isSelected"
      )
        .bound-title
          span.number 3
          span 簽署
            a(
              @click="openTermsModel"
            ) 「BA One-On-One 服務使用條款
        .check-area
          .form-check
            input#agree(
              type='checkbox' 
              name='agree' 
              v-model='agree'
            )
            label.agree(
              for='agree'
            ) 我已詳閱並同意相關使用須知
        .d-flex.w-100.align-items-center.justify-content-center(
          style="padding: 20px 0"
          v-show="isSelected"
        )
          .col-7
            button.btn.btn-block.font-weight-bold(
              type="button",
              @click="bindHandler()",
              style="border: 4px solid #000;border-radius: 50px;padding: 0px 15px; background: #000; color: #fff",
            ) 確定
    Termsmodel(
      title="BA One-On-One服務使用條款",
    )
             
</template>

<script>
import { mapState } from 'vuex';
import { M_BIND_SA_SUCCESS } from '@/router/member/bind-sa';
import { M_CHANGE_SA_INDEX } from '@/router/member/change-sa';
import defaultPhotoStickerUrl from '@/assets/images/default/defaultProfileImg.png';
import Termsmodel from '@/components/customerModel/termsModel.vue';

export default {
  name: 'mySaUnbind',
  components: {
    Termsmodel
  },
  data() {
      return {
        citySelect: "",
        storeSelect:"",
        store:[],
        newSaList:[],
        isSelected: null,
        defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`,
        swiperOption: {
          slidesPerView: 2,
          spaceBetween: 10,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        agree: false
      }
  },
  mounted() {
    const vm = this;
      vm.$store.dispatch('member_my_sa/getSaListHandler')
      .then(() => {
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
      });
  },
  computed: {
    getCity() {
      return Object.keys(this.saList);
    },
    getStore() {
      return Object.keys(this.store);
    },
     ...mapState({
      saList: (state) => state.member_my_sa.saList
    })
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
    clickCity() {
      let item = Object.values(this.saList)[this.citySelect]
      this.store = item;
      this.storeSelect = "";
      this.isSelected = null;
    },
    clickStore() {
      let sa = Object.values(this.store)[this.storeSelect]
      this.newSaList = sa;
      this.isSelected = null;
    },
    openTermsModel() {
      const vm = this;
      vm.$EventBus.$emit('openTermsModel');
    },
    selectBaHandler(item) {
      this.isSelected = item;
    },
    bindHandler() {
      const vm = this; 
      if(!vm.agree) {
        vm.$swal.fire({
        icon: 'error',
        title: '請先同意相關使用須知',
        });
        return
      }
      const sa_id = this.isSelected.sa_id;
      const store_id = this.isSelected.store_id;
      vm.$store.commit('toggleLoading', false);
      vm.$swal.fire({
        title: '綁定中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

    if (!sa_id && !store_id) {
      vm.$swal.fire({
        icon: 'error',
        title: '綁定失敗，請重新再嘗試一次[Err1]',
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false
      });
      return;
    }

    vm.$store.dispatch('member_bind_sa/memberBindingSaHandler', {
      sa_id,
      store_id
    })
      .then((res) => {
        if (res.message === '請先加入官方帳號好友') {
          vm.$swal.fire({
            icon: 'info',
            title: '前往下一步',
            confirmButtonText: "確定",
          }).then(() => {
            location.href = `${process.env.VUE_APP_DOMAIN}/member/bind-sa?sa_id=${sa_id}&store_id=${store_id}`;
          });
          return;
        }
        if (res.message === 'success') {
          vm.$swal.close();
          vm.$store.commit('member_bind_sa/setSaInfo', {
            sa: res.data.after_sa,
            store: res.data.after_store
          });
          vm.$router.push({
            name: M_BIND_SA_SUCCESS
          });
        } else if (res.message === '進入換綁流程') {
          vm.$store.commit('member_change_sa/saveChangeSaInfo', res.data);
          vm.$swal.close();
          vm.$router.push({
            name: M_CHANGE_SA_INDEX
          });
        } else if (res.message === '進入開通會員流程') {
          vm.$swal.close();
          const token = window.sessionStorage.getItem('data');

          const domain = `${process.env.VUE_APP_MEMBER_BIND_URL}/member/bind/ba`;
          const url = `${domain}?sa_id=${res.data.sa_id}&store_id=${res.data.store_id}&token=${token}`;
          window.location = url;
        } else {
          vm.$swal.fire({
            icon: 'error',
            title: '綁定失敗，請重新再嘗試一次[Err2]',
            showConfirmButton: false,
            showCancelButton: false
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.btn.btn-primary {
  background: #000 !important;
  border-color: #000 !important;
  color: #fff;
}
.btn.btn-disabled {
  background: #b5b5b5;
  border-color: #b5b5b5;
  color: #fff;
}
select {
  border: 0;
  outline: 0;
  background-color: #eee;
  font-size: 16px;
  padding: 10px 15px;
  border-radius: 9487px;
  width: 100%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;}

.swiper-pagination ::v-deep
  .swiper-pagination-bullet-active{
     background-color: #000;
     opacity: 0.5;
}
   
  .bound-area{
    padding: 0 3%;}
    .bound-wrap {
      padding: 30px 4%;}
      .bound-wrap + .bound-wrap {
          border-top: 1px solid #ccc;}
      .title-area {
        margin-top: 80px;
        position: relative;
          &:before, &:after{
          position: absolute;
          content: "";
          width: 1px;
          height: 120%;
          background-color: #000;
          top: 0;
          -webkit-transform-origin: center bottom;
          transform-origin: center bottom;
          }
          &:before{
          left: 2rem;
            -webkit-transform: rotate(-20deg);
            transform: rotate(-20deg);
          }
          &:after{
            right: 2rem;
            -webkit-transform: rotate(20deg);
            transform: rotate(20deg);
          }
      }
        .title {
          font-size: 20px;
          margin-bottom: 0;
          font-weight: 800;}
        .subtitle {
          font-size: 18px;
          margin-bottom: 0;
          font-weight: 800;}
         @media (max-width: 340px) {
           .title {
            font-size: 16px;}
          .subtitle {
            font-size: 14px;}}
      .bound-title {
        font-size: 16px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        font-weight: 500;
        margin-bottom: 20px;}
       span.number {
          color: #fff;
          width: 25px;
          height: 25px;
          background-color: #ffe19f;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          margin-right: 10px;}
      span a{
        text-decoration: underline !important; 
       }
      .bound-selector {
        padding: 0 1.5rem;
      }
      .bound-selector select{
        background-color: #fff;
        border: 1px solid #999;
        border-radius: 0;
        color: #000;
        font-weight: 500;
        background-image: url(../../../assets/images/icon/arrow-dropdown-1.png);
        background-repeat: no-repeat;
        background-size: 17px;
        background-position: center right 15px;}
        select + select {
          margin-top: 10px;}
      .b-card {
        border: 1px solid #dadada;
        text-align: center;
        position: relative;
        }
        .badge-img {
          position: absolute;
          right: 0;
          top: 95px;
          max-width: 16vw;
          height: auto;
        }
        .head-img {
          width: 100%;
          height: 160px;
          overflow: hidden;}
           @media (min-width: 768px) {
           .badge-img{
              top: 180px;}
           .head-img{
             height: 300px;}}
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;}
        .name {
          font-size: 18px;}
        .location span {
          font-size: 12px;}
      .btn {
        font-weight: 700;
        padding: 3px 40px;}
      .swiper-pagination-bullet-active {
        background:rgba(0, 0, 0, 0.5)!important;
      }
  .check-area{
    .form-check{
      text-align: center;
    }
  }
/*------ check-box ------*/
[type="checkbox"] {
	&:checked {
		position: absolute;
		left: -9999px;
		+ {
			label {
				position: relative;
				padding-left: 20px;
				cursor: pointer;
				line-height: 14px;
				display: inline-block;
				color: #000;
				&:before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					width: 14px;
					height: 14px;
					border: 1px solid #000;
					background: #fff;
				}
				&:after {
					content: '';
					width: 8px;
					height: 8px;
					background: #000;
					position: absolute;
					top: 3px;
					left: 3px;
					-webkit-transition: all 0.2s ease;
					transition: all 0.2s ease;
					opacity: 1;
					-webkit-transform: scale(1);
					transform: scale(1);
				}
			}
		}
	}
	&:not(:checked) {
		position: absolute;
		left: -9999px;
		+ {
			label {
				position: relative;
				padding-left: 20px;
				cursor: pointer;
				line-height: 14px;
				display: inline-block;
				color: #000;
				&:before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					width: 14px;
					height: 14px;
					border: 1px solid #000;
					background: #fff;
				}
				&:after {
					content: '';
					width: 8px;
					height: 8px;
					background: #000;
					position: absolute;
					top: 3px;
					left: 3px;
					-webkit-transition: all 0.2s ease;
					transition: all 0.2s ease;
					opacity: 0;
					-webkit-transform: scale(0);
					transform: scale(0);
				}
			}
		}
	}
}
</style>
